import { createContext } from 'react';
import { FocusTrapContextProps } from './types';

export const FocusTrapContext = createContext<FocusTrapContextProps>({
	reInitFocusTrap: () => {},
	disableFocusTrap: () => {},
});
